import React  from "react";
import { connect } from "react-redux";
import Awards from "./components/Awards";

const EmployeeRewards = () => {
  return (
    <div className="space-y-6">
        <Awards />
    </div>
  );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeRewards);